import { render, staticRenderFns } from "./add-edit.vue?vue&type=template&id=606a2bce&scoped=true&"
import script from "./add-edit.vue?vue&type=script&lang=js&"
export * from "./add-edit.vue?vue&type=script&lang=js&"
import style0 from "./add-edit.vue?vue&type=style&index=0&id=606a2bce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606a2bce",
  null
  
)

export default component.exports